<template>
  <router-link
    :to="`/single-post/${_id}`"
    class="hover:shadow hover:rotate-3 transform duration-200 relative content-post"
  >
    <div
      class="border border-gray-200 bg-white md:h-96 h-60 flex items-center justify-center overflow-hidden"
    >
      <img :src="img" alt="post img" class="w-full h-full object-cover" />
    </div>
    <div class="content-post">
      <!-- name -->
      <div class="text-gray-600 flex justify-center text-lg font-medium">
        <span>{{ title }}</span>
      </div>

      <!-- content -->
      <div class="flex justify-center text-gray-700 font-semibold text-lg">
        <span>{{ description }}</span>
      </div>

      <!-- content -->
      <div class="flex justify-center text-gray-700 font-semibold text-lg">
        <span v-html="content"></span>
      </div>

    </div>
  </router-link>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    _id: String,
    img: String,
    title: String,
    description: String,
    content: String,
  },
};
</script>

<style scoped>
.content-post{
    text-overflow: ellipsis;
    overflow: hidden;
    height: 610px;
}

</style>
